import firebase from "firebase/app";
import "firebase/firestore";

import PostListModel from "./PostListModel";
import VideoListModel from "./VideoListModel";
import DataStore from "./DataStore";
import ClusterListModel from "./ClusterListModel";

var config = {};
// Load config based on environment
if (process.env.NODE_ENV === 'production') {
    config = {
        apiKey: "AIzaSyDyJs5SBvx3l0GwssTkcRDvby5SgulYhSw",
        authDomain: "inside-video-1eda4.firebaseapp.com",
        databaseURL: "https://inside-video-1eda4.firebaseio.com",
        projectId: "inside-video-1eda4",
        storageBucket: "inside-video-1eda4.appspot.com",
        messagingSenderId: "725122589072"
    };
} else {
    config = {
        apiKey: "AIzaSyBSEGmRG4VMLGXTenrAcM8u0unRVoJL2xg",
        authDomain: "inside-global-development.firebaseapp.com",
        databaseURL: "https://inside-global-development.firebaseio.com",
        projectId: "inside-global-development",
        storageBucket: "inside-global-development.appspot.com",
        messagingSenderId: "539457878378"
    };
}
firebase.initializeApp(config);

const dataStore = new DataStore();
const clusterStore = new ClusterListModel();
const postStore = new PostListModel();
const videoStore = new VideoListModel();

export default {
    clusterStore: clusterStore,
    dataStore: dataStore,
    postStore: postStore,
    videoStore: videoStore
};



// WEBPACK FOOTER //
// ./src/models/index.js